/* AGNES TOTH — home page animations (GSAP + ScrollTrigger).
   Built section by section on art direction. Skips entirely for
   prefers-reduced-motion and inside the theme editor. */
(function () {
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var design = !!(window.Shopify && window.Shopify.designMode);
  if (reduce || design || !window.gsap || !window.ScrollTrigger) {
    document.documentElement.classList.remove('agnes-anim-pending');
    return;
  }

  var AGNES_BUILD = 'fast-veil-1';
  window.AGNES_BUILD = AGNES_BUILD;

  /* Transitions are desktop-only; mobile/tablet keep parallax + fades. */
  var DESKTOP = window.matchMedia('(min-width: 1025px)').matches;
  var TPL = (function () {
    var m = document.querySelector('main[data-template]');
    return (m && m.dataset.template) || '';
  })();

  /* Mobile fallback: play a paused tween once when the wrapper's bottom is
     first fully in view (runtime rect — trap-immune). */
  function playWhenFullyVisible(wrapEl, tween) {
    if (!tween) return;
    var done = false;
    var g = function () {
      if (!done && wrapEl.getBoundingClientRect().bottom <= window.innerHeight + 2) {
        done = true; tween.play(); window.removeEventListener('scroll', g);
      }
    };
    window.addEventListener('scroll', g, { passive: true });
    g();
  }
  var gsap = window.gsap;
  gsap.registerPlugin(window.ScrollTrigger);

  /* --- Style B: key home sections fill the viewport height. min-height only,
         so on short viewports content-driven (scrollable) height survives;
         on tall screens no more under-filled sections breaking the
         choreography seams. Injected here = home-page-scoped for free
         (subpages share these section types and must not change). --- */
  var fillStyle = document.createElement('style');
  if (TPL === 'index' || DESKTOP) {
  fillStyle.textContent =
    '.agnes-hero { min-height: 100svh; }' +
    '.agnes-statement { min-height: 100svh; display: flex; flex-direction: column; justify-content: center; }' +
    '.agnes-cats { min-height: 100svh; display: flex; flex-direction: column; justify-content: center; }' +
    '.agnes-cats .agnes-cats__grid { width: 100%; }' +
    /* desktop: the grid/tiles are aspect-locked and letterbox inside the
       100svh section (white bands) — release them and stretch to fill */
    '@media screen and (min-width: 750px) {' +
      '.agnes-cats .agnes-cats__grid { flex: 1 1 auto; aspect-ratio: auto !important; }' +
      '.agnes-cats .agnes-cats__tile { aspect-ratio: auto !important; height: 100%; min-height: 0; }' +
      '.agnes-cats .agnes-cats__image { width: 100%; height: 100%; object-fit: cover; }' +
    '}' +
    /* editorials (piece, woman, budapest, sustainability): the section sets
       --ed-min-height INLINE, so the property needs important */
    '.agnes-editorial { min-height: 100svh !important; }' +
    /* woman + budapest viewport locks are TABLET/DESKTOP-ONLY — on phones the
       budapest band stacks text + a full-viewport image (its own mobile rule). */
    '@media (min-width: 750px) {' +
      '.shopify-section[id*="__woman"] .agnes-editorial,' +
      '.shopify-section[id*="budapest"] .agnes-editorial { height: 100svh !important; }' +
      '.shopify-section[id*="budapest"] .agnes-editorial__media { aspect-ratio: auto !important; height: 100%; align-self: stretch; min-height: 0; }' +
      '.agnes-editorial--fixed-aspect .agnes-editorial__media { aspect-ratio: auto !important; width: 100%; height: 100%; min-height: 0; }' +
    '}' +
    '.shopify-section[id*="budapest"] .agnes-editorial__media .agnes-editorial__image { height: 100%; width: 100%; object-fit: cover; }' +
    '.agnes-editorial--fixed-aspect .agnes-editorial__image { width: 100%; height: 100%; object-fit: cover; }' +
    /* the aspect can live on the SECTION ELEMENT itself (overlay variants):
       with the forced viewport height it computed the whole section narrower
       than its wrapper — the "slid to the left" ghost */
    '.agnes-editorial--fixed-aspect { aspect-ratio: auto !important; width: 100%; }';
  document.head.appendChild(fillStyle);
  }

  /* Late consistency pass: recompute all trigger positions once every pin and
     spacer exists — initial refresh order can under-count pin spacing for
     triggers far down the page. */
  window.addEventListener('load', function () {
    setTimeout(function () { window.ScrollTrigger.refresh(); }, 800);
  });

  /* --- Lenis smooth scrolling: fast wheel flicks become eased motion, so the
         scrubbed choreography can't be skipped through. Touch stays native
         (syncTouch off by default); reduced-motion users never get here. --- */
  if (window.Lenis) {
    var style = document.createElement('style');
    style.textContent =
      /* horizontal bleed guard: off-screen sweeps/pushes must not widen the page */
      'html, body { overflow-x: clip; }' +
      'html.lenis, html.lenis body { height: auto; }' +
      '.lenis.lenis-smooth { scroll-behavior: auto !important; }' +
      '.lenis.lenis-smooth [data-lenis-prevent] { overscroll-behavior: contain; }' +
      '.lenis.lenis-stopped { overflow: hidden; }';
    document.head.appendChild(style);

    var lenis = new window.Lenis({
      duration: 1.4,
      wheelMultiplier: 0.7,   // tame per-tick distance
      /* hard cap: clamp each wheel/touch delta so violent flicks can't spike
         the velocity — the choreography always gets its frames */
      virtualScroll: function (data) {
        var MAX = 140;
        if (data.deltaY > MAX) data.deltaY = MAX;
        else if (data.deltaY < -MAX) data.deltaY = -MAX;
        return true;
      }
    });
    lenis.on('scroll', window.ScrollTrigger.update);
    gsap.ticker.add(function (time) { lenis.raf(time * 1000); });
    gsap.ticker.lagSmoothing(0);
  }

  /* Reloading while scrolled deep: the browser restores an arbitrary scroll
     position and the choreography would initialise mid-transition (frozen
     pins, dead timelines). Land on the nearest section top instead — every
     timeline then starts from a clean 0/1 state. Re-align after the late
     refresh in case images shifted the layout. (docTop is hoisted.) */
  var snapSection = null;
  (function () {
    /* Chrome restores the scroll position ASYNCHRONOUSLY — it can land after
       this script has armed every trigger, so reading window.scrollY here is
       not enough. Take restoration over: remember the position ourselves
       (per path) and re-apply it only on real reloads, snapped to a section. */
    if ('scrollRestoration' in history) history.scrollRestoration = 'manual';
    var KEY = 'agnesY:' + location.pathname;
    window.addEventListener('scroll', function () {
      try { sessionStorage.setItem(KEY, window.scrollY); } catch (e) {}
    }, { passive: true });
    var savedY = 0;
    try { savedY = +sessionStorage.getItem(KEY) || 0; } catch (e) {}
    var nav = performance.getEntriesByType && performance.getEntriesByType('navigation')[0];
    var isReload = nav && (nav.type === 'reload' || nav.type === 'back_forward');
    var y = Math.max(window.scrollY, isReload ? savedY : 0);
    if (y < 10) return;
    /* Desktop lands on the nearest section top (clean 0/1 timeline states);
       mobile has no structural pins, so it returns to the exact position. */
    if (DESKTOP) {
      var secs = document.querySelectorAll('#MainContent > .shopify-section');
      var bd = Infinity;
      Array.prototype.forEach.call(secs, function (s) {
        var d = Math.abs(docTop(s) - y);
        if (d < bd) { bd = d; snapSection = s; }
      });
      if (!snapSection) return;
    }
    /* Creating ScrollTriggers while the page is scrolled crashes ST's
       refresh (undefined 'end'), killing the whole engine — so build
       everything from the pristine top-of-page state every normal load
       uses, veil the page meanwhile, and jump once the late refresh ran. */
    window.scrollTo(0, 0);
    var veil = document.createElement('style');
    veil.textContent = 'html { visibility: hidden !important; }';
    document.head.appendChild(veil);
    var jumped = false;
    var target = function () { return snapSection ? docTop(snapSection) : y; };
    var jump = function () {
      if (jumped) return;
      jumped = true;
      window.scrollTo(0, target());
      if (window.ScrollTrigger) window.ScrollTrigger.update();
      setTimeout(function () { veil.remove(); }, 40);
    };
    var correct = function () {
      window.scrollTo(0, target());
      if (window.ScrollTrigger) window.ScrollTrigger.update();
    };
    /* the engine's tail calls this via double-rAF — first stable frame */
    window.__agnesSnapJump = jump;
    window.addEventListener('load', function () { setTimeout(function () { if (jumped) { correct(); } else { jump(); } }, 950); });
    setTimeout(jump, 2600); /* safety — never leave the page veiled */
  })();

  /* Wrap each character or word in a span so it can animate individually.
     Keeps nested markup (e.g. <em>) intact; whitespace stays as text nodes.
     Note: per-char spans defeat font kerning (the line grows slightly wider),
     so large display headings must use 'word' mode to keep their line breaks. */
  function split(el, mode) {
    var spans = [];
    function walk(node) {
      if (node.nodeType === 3) {
        var frag = document.createDocumentFragment();
        var tokens = mode === 'word' ? node.nodeValue.split(/(\s+)/) : node.nodeValue.split('');
        tokens.forEach(function (t) {
          if (t === '') return;
          if (t.trim() === '') { frag.appendChild(document.createTextNode(t)); return; }
          var s = document.createElement('span');
          s.textContent = t;
          if (mode === 'word') s.style.display = 'inline-block';
          spans.push(s);
          frag.appendChild(s);
        });
        node.parentNode.replaceChild(frag, node);
      } else if (node.nodeType === 1) {
        Array.prototype.slice.call(node.childNodes).forEach(walk);
      }
    }
    var label = el.textContent;
    walk(el);
    el.setAttribute('aria-label', label.trim());
    return spans;
  }

  /* Position-based sweep: one wipe travels along the axis; each part starts its
     blur→sharp fade when the wipe reaches its position. Same-line parts on the
     'y' axis share a top, so a vertical sweep reveals line by line. */
  function sweep(parts, axis, opts) {
    if (!parts.length) return;
    var pos = parts.map(function (s) {
      var r = s.getBoundingClientRect();
      return axis === 'y' ? r.top : r.left;
    });
    var min = Math.min.apply(null, pos);
    var span = Math.max(Math.max.apply(null, pos) - min, 1);
    var vars = {
      opacity: 1,
      filter: 'blur(0px)',
      duration: opts.part,
      ease: 'power2.out',
      delay: opts.delay || 0,
      stagger: function (i) { return ((pos[i] - min) / span) * (opts.total - opts.part); }
    };
    if (opts.trigger) vars.scrollTrigger = { trigger: opts.trigger, start: opts.start, once: true };
    gsap.to(parts, vars);
  }

  /* Document offset via the offsetParent chain: transform-immune (unlike
     rects), so it stays honest for elements whose inner content we animate.
     Never call on a PINNED (fixed) element — the chain collapses to 0. */
  function docTop(el) {
    var y = 0;
    while (el) { y += el.offsetTop; el = el.offsetParent; }
    return y;
  }

  /* Drive a transition timeline from the incoming wrapper's REAL viewport
     position (progress 0 = top at viewport bottom, 1 = top at viewport top).
     ScrollTrigger's precomputed ranges under-count pin spacers above and can
     shift whole transitions into the wrong scroll window; rects can't lie.
     The wrapper must be untransformed and unpinned during its entry (all
     ours are — pins engage at/after landing, where the rect freezes at 1). */
  function rectDrive(wrapEl, timeline, onProgress) {
    timeline.pause();
    var f = function () {
      var p = 1 - wrapEl.getBoundingClientRect().top / window.innerHeight;
      p = Math.max(0, Math.min(1, p));
      timeline.progress(p);
      if (onProgress) onProgress(p);
    };
    gsap.ticker.add(f);
    window.ScrollTrigger.addEventListener('refresh', function () { timeline.invalidate(); });
    f();
  }

  /* --- Hero: one left → right sweep across all text, blurred → sharp, 2.5s --- */
  (function () {
    var content = document.querySelector('.agnes-hero__content');
    if (!content) { document.documentElement.classList.remove('agnes-anim-pending'); return; }

    var parts = [];
    [
      ['.agnes-hero__eyebrow', 'char'],
      ['.agnes-hero__heading', 'char'],   // safe: desktop heading is nowrap, so kerning-loss widening can't rewrap it
      ['.agnes-hero__subheading', 'word'],
      ['.agnes-hero__cta', 'char']
    ].forEach(function (t) {
      var el = content.querySelector(t[0]);
      if (el) parts = parts.concat(split(el, t[1]));
    });
    if (!parts.length) { document.documentElement.classList.remove('agnes-anim-pending'); return; }

    gsap.set(parts, { opacity: 0, filter: 'blur(8px)' });

    // Initial states are on the spans now — safe to lift the CSS pre-hide.
    document.documentElement.classList.remove('agnes-anim-pending');

    /* Measure positions only after the display font is in: fallback metrics
       wrap the char spans differently (the heading's last span landed on its
       own line at x=min, so it swept in with the FIRST letters on mobile). */
    var swept = false;
    var go = function () {
      if (swept) return;
      swept = true;
      sweep(parts, 'x', { total: 2.5, part: 1.2, delay: 0.2 });
    };
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(go);
      setTimeout(go, 1200); /* cap — never hold the intro hostage to a slow font */
    } else { go(); }
  })();

  /* --- Statement: the whole text block fades in as one surface — a soft
         gradient mask wipes down over it while its blur resolves. --- */
  (function () {
    var mainEl = document.querySelector('main[data-template]');
    if (mainEl && mainEl.dataset.template !== 'index') return;   // home only — subpage quotes stay in place
    var sec = document.querySelector('.agnes-statement');
    if (!sec) return;
    var block = sec.querySelector('.agnes-statement__inner') || sec;

    var state = { p: 0 };   // wipe front, in % of block height (soft edge trails 40% behind)
    function applyMask() {
      var m = 'linear-gradient(to bottom, rgba(0,0,0,1) ' + (state.p - 40) + '%, rgba(0,0,0,0) ' + state.p + '%)';
      block.style.webkitMaskImage = m;
      block.style.maskImage = m;
    }
    applyMask();
    block.style.filter = 'blur(8px)';

    gsap.timeline({ scrollTrigger: { trigger: sec, start: 'top 75%', once: true } })
      .to(state, { p: 140, duration: 2.5, ease: 'power2.out', onUpdate: applyMask }, 0)
      .to(block, { filter: 'blur(0px)', duration: 2.5, ease: 'power2.out' }, 0)
      .add(function () {   // leave no mask/filter behind once done
        block.style.webkitMaskImage = block.style.maskImage = '';
        block.style.filter = '';
      });

  })();

  /* --- Categories: grows out of the screen centre. The statement pins while
         the tiles scale up from nothing at the viewport centre, landing
         full-size exactly at their resting position. --- */
  (function () {
    var stmt = document.querySelector('.agnes-statement');
    var cats = document.querySelector('.agnes-cats');
    if (!stmt || !cats) return;
    var stmtWrap = stmt.closest('.shopify-section');
    var catWrap = cats.closest('.shopify-section');
    if (!stmtWrap || !catWrap) return;
    if (!DESKTOP) return;   // grow transition + hold — desktop only

    /* Scroll distance of the transition = gap between the two section tops.
       Must be transform-immune (offsetTop, not rects): we translate the inner
       section ourselves, and rect-based math collapsed the range to ~1px. */
    function dist() {
      return Math.max(docTop(catWrap) - docTop(stmtWrap), 1);
    }

    /* dist() lies while the statement is PINNED (fixed → offsetParent chain
       collapses to 0). Tween from-values may be lazily re-evaluated after a
       mid-scroll refresh re-pins, so they must read this cached value, which
       is only ever updated from ScrollTrigger's own reverted-state numbers. */
    var D = dist();

    gsap.set(stmtWrap, { zIndex: -1 });   // paints under the in-flow categories while pinned (fixed)

    /* The section's colour-scheme background would show around the individually
       growing tiles — let the statement backdrop show through instead. */
    gsap.set([catWrap, cats], { backgroundColor: 'transparent' });

    var tl = gsap.timeline({
      scrollTrigger: {
        trigger: stmtWrap,
        start: 'top top',
        end: function () { return '+=' + dist(); },
        scrub: true,
        pin: true,
        pinSpacing: false,
        invalidateOnRefresh: true,
        onRefresh: function (self) { D = self.end - self.start; },
        /* Hover-widening on the tiles is CSS-gated behind --armed: only
           interactive once the grow-in has fully landed. Progress-based —
           the step scroll lands exactly ON the end boundary, where onLeave
           alone may never fire. */
        onUpdate: function (self) {
          cats.classList.toggle('agnes-cats--armed', self.progress > 0.55);
        },
        onLeave: function () { cats.classList.add('agnes-cats--armed'); },
        onEnterBack: function () { cats.classList.remove('agnes-cats--armed'); }
      }
    });

    /* Dwell: the first OFF px of the pinned range play nothing — the statement
       just sits — then the grow runs in the remaining scroll. HOLD converts the
       px offset into leading empty timeline time under the linear scrub. */
    /* OFFSET DISABLED (restore by uncommenting):
    var OFF = Math.min(Math.round(window.innerHeight * 0.35), Math.round(D * 0.5));
    var HOLD = OFF / Math.max(D - OFF, 1);
    */
    var OFF = 0, HOLD = 0;

    /* y cancels the scroll exactly across the post-dwell range, so the section
       sits at its final screen position throughout the grow; the only motion is
       a subtle scale-up from the statement's centre, with fade and a soft blur.
       It turns opaque almost instantly (autoAlpha also keeps it unclickable
       while hidden); the visible fade is per-tile, staggered.
       All transforms live on the INNER section element — the wrapper stays
       untransformed so the dwell pin below can't fight over inline styles
       (ScrollTrigger snapshots/restores the pinned element's transform). */
    tl.fromTo(cats,
      {
        y: function () { return -(D - OFF); },
        scale: 0.6,
        transformOrigin: function () { return '50% ' + stmtWrap.offsetHeight / 2 + 'px'; }
      },
      { y: 0, scale: 1, ease: 'none', duration: 1 },
      HOLD
    );
    /* blur resolves well before the growth completes */
    tl.fromTo(cats, { filter: 'blur(6px)' }, { filter: 'blur(0px)', ease: 'none', duration: 0.45 }, HOLD);
    tl.fromTo(cats, { autoAlpha: 0 }, { autoAlpha: 1, ease: 'none', duration: 0.12 }, HOLD);

    /* Per-tile: fades finish fast (by ~55% of the transit); growth runs on. */
    var tiles = cats.querySelectorAll('.agnes-cats__tile');
    if (tiles.length > 1) {
      /* seam-anchored origins: the tiles stay glued at the centre line while
         growing — no gap opens between them */
      tl.fromTo(tiles[0], { autoAlpha: 0 }, { autoAlpha: 1, ease: 'none', duration: 0.35 }, HOLD + 0.05);
      tl.fromTo(tiles[0], { scale: 0.85, transformOrigin: '100% 50%' },
        { scale: 1, ease: 'none', duration: 0.55 }, HOLD + 0.05);
      tl.fromTo(tiles[1], { autoAlpha: 0 }, { autoAlpha: 1, ease: 'none', duration: 0.45 }, HOLD + 0.1);
      tl.fromTo(tiles[1], { scale: 0.85, transformOrigin: '0% 50%' },
        { scale: 1, ease: 'none', duration: 0.9 }, HOLD + 0.1);
    }

    /* The statement text blurs and fades away underneath, like the hero text.
       Targets __body: not __inner (the intro mask owns it — pre-rendering
       start values there clobbered its blur) and not the wrapper (fading it
       took the opaque background along and the hero showed through).
       Explicit from-values so the reverse scrub always lands fully sharp. */
    tl.fromTo(stmt.querySelector('.agnes-statement__body') || stmt,
      { opacity: 1, filter: 'blur(0px)' },
      { opacity: 0, filter: 'blur(8px)', ease: 'none', duration: 0.45 },
      HOLD
    );

    /* Same dwell AFTER the categories: once landed, the tiles hold for a
       stretch of scroll (pin with spacing — the next section waits below)
       before the page moves on. Numeric start/end via the offset chain:
       rect-based trigger positions read catWrap's from-state TRANSFORM at
       refresh time and land the range mid-statement (the recurring trap). */
    /* The one deliberate hold on the page: the tiles rest for 55% of a
       viewport after the grow-in lands. */
    window.ScrollTrigger.create({
      trigger: catWrap,
      start: function () { return docTop(catWrap); },
      end: function () { return docTop(catWrap) + Math.round(window.innerHeight * 0.55); },
      pin: true,
      pinSpacing: true,
      invalidateOnRefresh: true
    });
  })();

  /* --- Hero exit: hero pins while the next section slides up over it.
         The hero drifts up slowly (the "kinda parallax") and its text
         fades out over the first half of the scroll. --- */
  (function () {
    var hero = document.querySelector('.agnes-hero');
    var wrap = hero && hero.closest('.shopify-section');
    if (!wrap) return;
    if (!DESKTOP) return;   // transition — desktop only

    /* While pinned the wrapper is position:fixed; z-index -1 drops it into the
       negative band so the in-flow sections after it paint on top as they
       scroll over. Ignored whenever the wrapper is static again. */
    gsap.set(wrap, { zIndex: -1 });

    var tl = gsap.timeline({
      scrollTrigger: {
        trigger: wrap,
        start: 'top top',
        end: 'bottom top',   // exactly until the next section's start — '+=100%' outlived it on viewports taller than the hero's 1000px cap
        scrub: true,
        pin: true,
        pinSpacing: false
      }
    });
    tl.to(hero, { yPercent: -12, ease: 'none', duration: 1 }, 0);
    tl.to(hero.querySelector('.agnes-hero__content'), { opacity: 0, filter: 'blur(8px)', ease: 'none', duration: 0.35 }, 0);
  })();

  /* --- Collection showcases (Poppy + Thermal, identical params): subtle
         bottom→top mask fade + blur on entry, product cards slide up into
         place slightly staggered, the promo slideshow drifts as parallax. --- */
  document.querySelectorAll('.agnes-collection').forEach(function (sec) {
    var wrap = sec.closest('.shopify-section');
    if (!wrap) return;

    /* 1+2) Entrance fades are DESKTOP-only (mobile shows the section plainly —
          client feedback); the promo parallax below runs on all widths. */
    if (DESKTOP) {
    var reveal = { p: 0 };
    function applyMask() {
      var m = 'linear-gradient(to top, rgba(0,0,0,1) ' + (reveal.p - 40) + '%, rgba(0,0,0,0) ' + reveal.p + '%)';
      sec.style.webkitMaskImage = m;
      sec.style.maskImage = m;
    }
    applyMask();
    sec.style.filter = 'blur(6px)';
    var entry = gsap.timeline({ paused: true })
      .to(reveal, { p: 140, duration: 2, ease: 'power2.out', onUpdate: applyMask }, 0)
      .to(sec, { filter: 'blur(0px)', duration: 2, ease: 'power2.out' }, 0)
      .add(function () {   // leave no mask/filter behind
        sec.style.webkitMaskImage = sec.style.maskImage = '';
        sec.style.filter = '';
      });

    /* 2) Product cards slide into place bottom→top, a tad offset from each other. */
    var cards = sec.querySelectorAll('.agnes-collection__card');
    var cardsTween = null;
    if (cards.length) {
      gsap.set(cards, { y: 56, autoAlpha: 0 });
      cardsTween = gsap.to(cards, {
        y: 0, autoAlpha: 1, duration: 1.1, ease: 'power3.out', stagger: 0.14, paused: true
      });
    }

    /* Entrances fire from the wrapper's REAL on-screen position at runtime —
       refresh-time trigger positions under-count the pin spacers above
       (thermal's fired ~half a viewport early, beneath the pinned spinner). */
    var entryDone = false, cardsDone = false;
    function entranceGate() {
      var top = wrap.getBoundingClientRect().top;
      if (!entryDone && top < window.innerHeight * 0.70) { entryDone = true; entry.play(); }
      if (!cardsDone && top < window.innerHeight * 0.65 && cardsTween) { cardsDone = true; cardsTween.play(); }
      if (entryDone && (cardsDone || !cardsTween)) window.removeEventListener('scroll', entranceGate);
    }
    window.addEventListener('scroll', entranceGate, { passive: true });
    entranceGate();
    }

    /* 3) Slideshow parallax: the promo media drifts ±15%, slightly oversized
          so the drift never shows edges (clipped by the promo tile).
          Driven by the SECTION's visual position (the inner element that the
          piece-made transition drifts upward) — so the parallax keeps moving
          whenever the section visually moves, pinned or not, and holds still
          during the dwell when the section holds. */
    var media = sec.querySelector('.agnes-collection__promo-media');
    if (media) {
      gsap.set(media, { scale: 1.32 });
      var setYP = gsap.quickSetter(media, 'yPercent');
      var updateParallax = function () {
        var r = sec.getBoundingClientRect();
        var t = (window.innerHeight - r.top) / (window.innerHeight + r.height);
        t = Math.max(0, Math.min(1, t));
        setYP(-15 + 30 * t);
      };
      window.ScrollTrigger.create({
        trigger: wrap,
        /* generous numeric range: the wrapper stays put (pinned) well past its
           own height while a later section slides over — cover that whole life */
        start: function () { return docTop(wrap) - window.innerHeight; },
        end: function () { return docTop(wrap) + wrap.offsetHeight + window.innerHeight * 2.5; },
        invalidateOnRefresh: true,
        onUpdate: updateParallax,
        onRefresh: updateParallax
      });
      updateParallax();
    }
  });

  /* --- "A piece made only for you": slides up in front of the pinned Poppy
         showcase (statement-over-hero pattern), then the boxed card grows in
         from its centre and its contents cascade. --- */
  (function () {
    var pieceWrap = document.querySelector('.shopify-section[id*="piece_made"]');
    var piece = pieceWrap && pieceWrap.querySelector('.agnes-editorial');
    var poppySec = document.querySelector('.agnes-collection');
    var poppyWrap = poppySec && poppySec.closest('.shopify-section');
    if (!pieceWrap || !piece || !poppyWrap) return;

    /* Dwell: a real 35vh spacer between Poppy and the piece section delays the
       slide-over — Poppy holds pinned at rest for that stretch first. (The
       pin below uses pinSpacing:false, so the spacer is what makes the room;
       it is never visible — pinned Poppy covers the viewport across it.) */
    /* OFFSET DISABLED (restore by uncommenting):
    var dwellSpacer = document.createElement('div');
    dwellSpacer.style.cssText =
      'display:block !important; width:100%; height:35vh; min-height:35vh; flex:0 0 auto;';
    dwellSpacer.setAttribute('aria-hidden', 'true');
    poppyWrap.parentNode.insertBefore(dwellSpacer, poppyWrap.nextSibling);
    */

    /* Slide-over: Poppy pins (from its fully-seen, bottom-aligned state —
       it's taller than the viewport) while the piece section scrolls up over
       it. The PIECE is raised above rather than dropping Poppy to z:-1 —
       negative z on a flex item kills all hover/click hit-testing (pointer
       events land on <main>), and Poppy is interactive. */
    gsap.set(pieceWrap, { position: 'relative', zIndex: 2 });
    if (DESKTOP) window.ScrollTrigger.create({
      trigger: poppyWrap,
      start: function () { return docTop(poppyWrap) + Math.max(poppyWrap.offsetHeight - window.innerHeight, 0); },
      end: function () { return docTop(pieceWrap); },
      pin: true,
      pinSpacing: false,
      invalidateOnRefresh: true
    });

    /* While the piece slides over (after the dwell), the pinned Poppy isn't
       frozen — its content drifts up slowly, the hero-exit "kinda parallax".
       Drift on the INNER section element; folded into the rect-driven curtain
       timeline below (same range: the piece's entry). */

    /* Curtain entry: background AND content (box, texts, steps) stay glued to
       their final viewport positions while the section's rising edge reveals
       them — nothing moves with the section, the edge does the revealing.
       Only the bg gets the slight zoom-out. */
    var bgMedia = piece.querySelector('.agnes-editorial__media');
    var pieceFrame = piece.querySelector('.agnes-editorial__frame');
    if (DESKTOP) {
      gsap.set(piece, { overflow: 'hidden' });   // the curtain edge clips the glued layers
      var pieceCurtain = gsap.timeline();
      if (bgMedia) {
        pieceCurtain.fromTo(bgMedia,
          { y: function () { return -window.innerHeight; }, scale: 1.06 },
          { y: 0, scale: 1, ease: 'none', duration: 1 }, 0);
      }
      if (pieceFrame) {
        pieceCurtain.fromTo(pieceFrame,
          { y: function () { return -window.innerHeight; } },
          { y: 0, ease: 'none', duration: 1 }, 0);
      }
      pieceCurtain.fromTo(poppySec,
        { yPercent: 0 }, { yPercent: -25, ease: 'none', duration: 1 }, 0);
      rectDrive(pieceWrap, pieceCurtain);
    }

    /* Card entrance, once the section has mostly arrived. The title rides
       inside the box untouched; description → button → steps cascade after. */
    var box = piece.querySelector('.agnes-editorial__content');
    var body = piece.querySelector('.agnes-editorial__body');
    var btn = piece.querySelector('.agnes-editorial__btn, .agnes-editorial__link');
    var steps = piece.querySelectorAll('.agnes-editorial__step');
    if (!box) return;

    gsap.set(box, { scale: 0.7, autoAlpha: 0, filter: 'blur(8px)', transformOrigin: '50% 50%' });
    var innerBits = [body, btn].filter(Boolean);
    if (innerBits.length) gsap.set(innerBits, { y: 24, autoAlpha: 0, filter: 'blur(6px)' });
    if (steps.length) gsap.set(steps, { y: 18, autoAlpha: 0, filter: 'blur(6px)' });

    var tl = gsap.timeline({
      scrollTrigger: { trigger: pieceWrap, start: 'top 30%', once: true }
    });
    tl.to(box, { scale: 1, autoAlpha: 1, filter: 'blur(0px)', duration: 0.9, ease: 'power2.out' }, 0);
    if (body) tl.to(body, { y: 0, autoAlpha: 1, filter: 'blur(0px)', duration: 0.8, ease: 'power2.out' }, 0.45);
    if (btn) tl.to(btn, { y: 0, autoAlpha: 1, filter: 'blur(0px)', duration: 0.8, ease: 'power2.out' }, 0.6);

    /* Steps wait for the section's BOTTOM to reach the viewport — played from
       the dwell pin below (its boundary IS "fully in view"), not their own
       trigger: an independent trigger's start evaluated before the earlier
       pins' spacers existed and fired hundreds of px early. */
    var stepsTween = steps.length
      ? gsap.to(steps, {
          y: 0, autoAlpha: 1, filter: 'blur(0px)', duration: 0.7, ease: 'power2.out', stagger: 0.15,
          paused: true
        })
      : null;

    /* Dwell + curtain exit: a real 35vh spacer delays the next section (the
       'woman' editorial), then ONE pin without spacing holds the piece — first
       through the dwell, then while the woman curtains up over it. */
    function pieceDwellStart() {
      return docTop(pieceWrap) + Math.max(pieceWrap.offsetHeight - window.innerHeight, 0);
    }
    var womanWrap = document.querySelector('.shopify-section[id*="__woman"]');
    /* OFFSET DISABLED (restore by uncommenting):
    var pieceSpacer = document.createElement('div');
    pieceSpacer.style.cssText =
      'display:block !important; width:100%; height:35vh; min-height:35vh; flex:0 0 auto;';
    pieceSpacer.setAttribute('aria-hidden', 'true');
    pieceWrap.parentNode.insertBefore(pieceSpacer, pieceWrap.nextSibling);
    */
    if (DESKTOP) {
      window.ScrollTrigger.create({
        trigger: pieceWrap,
        start: pieceDwellStart,
        end: function () {
          return womanWrap ? docTop(womanWrap) : pieceDwellStart() + Math.round(window.innerHeight * 0.35);
        },
        pin: true,
        pinSpacing: false,
        invalidateOnRefresh: true,
        onEnter: function () { if (stepsTween) stepsTween.play(); }
      });
    } else {
      playWhenFullyVisible(pieceWrap, stepsTween);   // no pin on mobile — rect gate
    }
  })();

  /* --- "The finest things are quiet" (woman): curtains up over the pinned
         piece — its background stays glued to the viewport (only a slight
         zoom-out), the rising section edge is the curtain. Texts scale down
         into position with fade + blur once it lands. --- */
  (function () {
    var womanWrap = document.querySelector('.shopify-section[id*="__woman"]');
    var woman = womanWrap && womanWrap.querySelector('.agnes-editorial');
    if (!womanWrap || !woman) return;

    gsap.set(womanWrap, { position: 'relative', zIndex: 3 });   // covers the pinned piece (z2)
    gsap.set(woman, { overflow: 'hidden' });                    // the curtain edge clips the glued bg

    /* Background AND content glued: the rising edge reveals the fully-formed
       section; nothing translates with it. Only the bg gets the zoom-out. */
    var media = woman.querySelector('.agnes-editorial__media');
    var womanFrame = woman.querySelector('.agnes-editorial__frame');
    var womanCurtain = gsap.timeline();
    if (DESKTOP) {
    if (media) {
      womanCurtain.fromTo(media,
        { y: function () { return -window.innerHeight; }, scale: 1.06 },
        { y: 0, scale: 1, ease: 'none', duration: 1 }, 0);
    }
    if (womanFrame) {
      womanCurtain.fromTo(womanFrame,
        { y: function () { return -window.innerHeight; } },
        { y: 0, ease: 'none', duration: 1 }, 0);
    }
    rectDrive(womanWrap, womanCurtain);
    }

    /* One entrance for the whole content box (texts + monogram logo together,
       no stagger): scales down into position with fade + blur. */
    var content = woman.querySelector('.agnes-editorial__content');
    if (content) {
      gsap.set(content, { scale: 1.12, autoAlpha: 0, filter: 'blur(6px)', transformOrigin: '50% 50%' });
      gsap.to(content, {
        scale: 1, autoAlpha: 1, filter: 'blur(0px)', duration: 1.0, ease: 'power2.out',
        scrollTrigger: { trigger: womanWrap, start: 'top 30%', once: true }
      });
    }

    /* Dwell + shutter exit: a real 35vh spacer delays the budapest section,
       then ONE pin (no spacing) holds the woman — through the hold, then
       while the budapest white shutter sweeps in over it. */
    function womanDwellStart() {
      return docTop(womanWrap) + Math.max(womanWrap.offsetHeight - window.innerHeight, 0);
    }
    var budaWrapRef = document.querySelector('.shopify-section[id*="budapest"]');
    /* OFFSET DISABLED (restore by uncommenting):
    var womanSpacer = document.createElement('div');
    womanSpacer.style.cssText =
      'display:block !important; width:100%; height:35vh; min-height:35vh; flex:0 0 auto;';
    womanSpacer.setAttribute('aria-hidden', 'true');
    womanWrap.parentNode.insertBefore(womanSpacer, womanWrap.nextSibling);
    */
    if (DESKTOP) window.ScrollTrigger.create({
      trigger: womanWrap,
      start: womanDwellStart,
      end: function () {
        return budaWrapRef ? docTop(budaWrapRef) : womanDwellStart() + Math.round(window.innerHeight * 0.35);
      },
      pin: true,
      pinSpacing: false,
      invalidateOnRefresh: true
    });
  })();

  /* --- "Where the city's beauty becomes wearable" (budapest): enters as a
         white shutter sweeping in from the right that reveals the section in
         place (no slide). The sweep pushes the pinned woman's image and
         content rightward, parallax-style (content faster than image). The
         revealed image drifts slightly right→left; the right-side content
         then slides in from the right with a fade. --- */
  (function () {
    var budaWrap = document.querySelector('.shopify-section[id*="budapest"]');
    var buda = budaWrap && budaWrap.querySelector('.agnes-editorial');
    if (!budaWrap || !buda) return;

    gsap.set(budaWrap, { position: 'relative', zIndex: 4 });   // above the pinned woman (z3)
    gsap.set(buda, { position: 'relative', zIndex: 1 });

    /* The white shutter lives in the wrapper, above the (clipped) section. */
    var sweep = null;
    if (DESKTOP) {
      sweep = document.createElement('div');
      /* display !important: the theme hides empty divs (same trap as the dwell
         spacers). Half the viewport wide — a passing band, not a full cover.
         Desktop-only: unanimated it would sit as a blank white block. */
      sweep.style.cssText = 'display:block !important; position:absolute; top:0; bottom:0; left:0; width:50%; background:#fff; z-index:2; pointer-events:none;';
      budaWrap.appendChild(sweep);
    }

    var wMedia = document.querySelector('.shopify-section[id*="__woman"] .agnes-editorial__media');
    var wFrame = document.querySelector('.shopify-section[id*="__woman"] .agnes-editorial__frame');
    var bMedia = buda.querySelector('.agnes-editorial__media');

    var tl = gsap.timeline();

    if (DESKTOP) {
    /* Vertical glue: section + shutter sit at their final viewport position
       for the whole transition — the motion is purely horizontal. */
    tl.fromTo(buda, { y: function () { return -window.innerHeight; } }, { y: 0, ease: 'none', duration: 1 }, 0);
    tl.fromTo(sweep, { y: function () { return -window.innerHeight; } }, { y: 0, ease: 'none', duration: 1 }, 0);

    /* The half-width band crosses the screen right → left (xPercent is
       relative to its OWN 50vw width: 200 = fully off right, -100 = fully
       off left). */
    tl.fromTo(sweep, { xPercent: 200 }, { xPercent: -100, ease: 'none', duration: 1 }, 0);

    /* The section is revealed behind the band's trailing edge — which crosses
       the viewport from p=1/3 (right edge) to p=1 (left edge). */
    tl.fromTo(buda,
      { clipPath: 'inset(0% 0% 0% 100%)' },
      { clipPath: 'inset(0% 0% 0% 0%)', ease: 'none', duration: 0.667 }, 0.333);

    /* Revealed image drifts a touch right → left as it settles. */
    if (bMedia) {
      tl.fromTo(bMedia,
        { x: function () { return Math.round(window.innerWidth * 0.05); } },
        { x: 0, ease: 'none', duration: 0.667 }, 0.333);
    }

    /* The shutter pushes the woman's layers rightward — content outruns image. */
    if (wMedia) {
      tl.fromTo(wMedia, { x: 0 },
        { x: function () { return -Math.round(window.innerWidth * 0.18); }, ease: 'none', duration: 0.6 }, 0);
    }
    if (wFrame) {
      tl.fromTo(wFrame, { x: 0 },
        { x: function () { return -Math.round(window.innerWidth * 0.32); }, ease: 'none', duration: 0.6 }, 0);
    }

    rectDrive(budaWrap, tl, function (p) {
      if (!bContentTween) return;
      var cp = Math.max(0, Math.min(1, (p - 0.4) / 0.5));
      if (cp > bContentTween.progress()) bContentTween.progress(cp);
    });
    }

    /* Right-side content: into place from the right with a fade, once. */
    /* Right-side content: choreographed WITH the shutter on the way down —
       a ratchet driven from the scrub (progress can only increase), so
       scrolling back up never fades it out again. */
    var bContent = buda.querySelector('.agnes-editorial__content');
    var bContentTween = null;
    if (bContent && DESKTOP) {
      gsap.set(bContent, { x: 70, autoAlpha: 0 });
      bContentTween = gsap.to(bContent, { x: 0, autoAlpha: 1, ease: 'none', duration: 1, paused: true });
    }

    /* Small dwell + shutter exit: a real 25vh spacer delays the spinner, then
       ONE pin (no spacing) holds budapest — through the hold, then while the
       spinner wipes in over it. */
    function budaDwellStart() {
      return docTop(budaWrap) + Math.max(budaWrap.offsetHeight - window.innerHeight, 0);
    }
    var spinWrapRef = document.querySelector('.shopify-section[id*="spinner"]');
    /* OFFSET DISABLED (restore by uncommenting):
    var budaSpacer = document.createElement('div');
    budaSpacer.style.cssText =
      'display:block !important; width:100%; height:25vh; min-height:25vh; flex:0 0 auto;';
    budaSpacer.setAttribute('aria-hidden', 'true');
    budaWrap.parentNode.insertBefore(budaSpacer, budaWrap.nextSibling);
    */
    if (DESKTOP) window.ScrollTrigger.create({
      trigger: budaWrap,
      start: budaDwellStart,
      end: function () {
        return spinWrapRef ? docTop(spinWrapRef) : budaDwellStart() + Math.round(window.innerHeight * 0.25);
      },
      pin: true,
      pinSpacing: false,
      invalidateOnRefresh: true
    });
  })();

  /* --- Spinner ("Made, Not Manufactured"): wipes in right → left as its own
         shutter — no white band, the section's clipped edge does the sweep —
         while the pinned budapest is pushed leftward, content outrunning
         image. Generous dwell after landing (same as the categories). --- */
  (function () {
    var spinWrap = document.querySelector('.shopify-section[id*="spinner"]');
    var spin = spinWrap && spinWrap.querySelector('.agnes-spinner');
    if (!spinWrap || !spin) return;

    gsap.set(spinWrap, { position: 'relative', zIndex: 5 });   // above the pinned budapest (z4)

    var bMedia = document.querySelector('.shopify-section[id*="budapest"] .agnes-editorial__media');
    var bFrame = document.querySelector('.shopify-section[id*="budapest"] .agnes-editorial__frame');

    var tl = gsap.timeline();

    if (DESKTOP) {
    /* Vertical glue + self-shutter: the section sits at its final viewport
       position the whole transition; its clipped left edge sweeps across. */
    tl.fromTo(spin, { y: function () { return -window.innerHeight; } }, { y: 0, ease: 'none', duration: 1 }, 0);
    tl.fromTo(spin,
      { clipPath: 'inset(0% 0% 0% 100%)' },
      { clipPath: 'inset(0% 0% 0% 0%)', ease: 'none', duration: 1 }, 0);

    /* Budapest pushed leftward under it — IMAGE faster than text here (the
       image sits left of the text; text outrunning it would slide onto it).
       Full duration: it keeps moving until the wipe fully covers it. */
    if (bMedia) {
      tl.fromTo(bMedia, { x: 0 },
        { x: function () { return -Math.round(window.innerWidth * 0.18); }, ease: 'none', duration: 1 }, 0);
    }
    if (bFrame) {
      tl.fromTo(bFrame, { x: 0 },
        { x: function () { return -Math.round(window.innerWidth * 0.14); }, ease: 'none', duration: 1 }, 0);
    }

    rectDrive(spinWrap, tl);
    }

    /* Generous dwell: hold for 75% of the viewport after landing. */
    function spinDwellStart() {
      return docTop(spinWrap) + Math.max(spinWrap.offsetHeight - window.innerHeight, 0);
    }
    /* The second deliberate hold (longer than the categories): the spinner
       rests for 75% of a viewport after landing — desktop only. */
    if (DESKTOP) window.ScrollTrigger.create({
      trigger: spinWrap,
      start: spinDwellStart,
      end: function () { return spinDwellStart() + Math.round(window.innerHeight * 0.75); },
      pin: true,
      pinSpacing: true,
      invalidateOnRefresh: true
    });
  })();

  /* --- Sustainability: exact piece_made treatment (layout mirrored in CSS,
         same choreography). Thermal pins + drifts up while this curtains over
         with glued bg/content; box + cascade on arrival (rect-gated — it sits
         below pinSpacing pins); steps on full reveal; 35% dwell at the end. --- */
  (function () {
    var susWrap = document.querySelector('.shopify-section[id*="sustainability"]');
    var sus = susWrap && susWrap.querySelector('.agnes-editorial');
    var thermal = document.querySelectorAll('.agnes-collection')[1];
    var thermalWrap = thermal && thermal.closest('.shopify-section');
    if (!susWrap || !sus || !thermalWrap) return;

    gsap.set(susWrap, { position: 'relative', zIndex: 6 });

    /* Dwell + curtain: 35vh spacer delays this section, one pin (no spacing)
       holds thermal through the hold and the curtain. */
    /* OFFSET DISABLED (restore by uncommenting):
    var thermalSpacer = document.createElement('div');
    thermalSpacer.style.cssText =
      'display:block !important; width:100%; height:35vh; min-height:35vh; flex:0 0 auto;';
    thermalSpacer.setAttribute('aria-hidden', 'true');
    thermalWrap.parentNode.insertBefore(thermalSpacer, thermalWrap.nextSibling);
    */

    function thermalHoldStart() {
      return docTop(thermalWrap) + Math.max(thermalWrap.offsetHeight - window.innerHeight, 0);
    }
    if (DESKTOP) window.ScrollTrigger.create({
      trigger: thermalWrap,
      start: thermalHoldStart,
      end: function () { return docTop(susWrap); },
      pin: true,
      pinSpacing: false,
      invalidateOnRefresh: true
    });

    /* Thermal counter-drift is folded into the rect-driven curtain below. */

    /* Curtain: bg + content glued to their final viewport positions; the
       rising edge reveals; only the bg gets the slight zoom-out. */
    var media = sus.querySelector('.agnes-editorial__media');
    var frame = sus.querySelector('.agnes-editorial__frame');
    gsap.set(sus, { overflow: 'hidden' });
    var curtain = gsap.timeline();
    if (DESKTOP) {
    if (media) {
      curtain.fromTo(media,
        { y: function () { return -window.innerHeight; }, scale: 1.06 },
        { y: 0, scale: 1, ease: 'none', duration: 1 }, 0);
    }
    if (frame) {
      curtain.fromTo(frame,
        { y: function () { return -window.innerHeight; } },
        { y: 0, ease: 'none', duration: 1 }, 0);
    }
    curtain.fromTo(thermal, { yPercent: 0 }, { yPercent: -25, ease: 'none', duration: 1 }, 0);
    rectDrive(susWrap, curtain);
    }

    /* Box + cascade, rect-gated at 30% viewport. */
    var box = sus.querySelector('.agnes-editorial__content');
    var body = sus.querySelector('.agnes-editorial__body');
    var btn = sus.querySelector('.agnes-editorial__btn, .agnes-editorial__link');
    var steps = sus.querySelectorAll('.agnes-editorial__step');
    if (box) {
      gsap.set(box, { scale: 0.7, autoAlpha: 0, filter: 'blur(8px)', transformOrigin: '50% 50%' });
      var innerBits = [body, btn].filter(Boolean);
      if (innerBits.length) gsap.set(innerBits, { y: 24, autoAlpha: 0, filter: 'blur(6px)' });
      var boxTl = gsap.timeline({ paused: true });
      boxTl.to(box, { scale: 1, autoAlpha: 1, filter: 'blur(0px)', duration: 0.9, ease: 'power2.out' }, 0);
      if (body) boxTl.to(body, { y: 0, autoAlpha: 1, filter: 'blur(0px)', duration: 0.8, ease: 'power2.out' }, 0.45);
      if (btn) boxTl.to(btn, { y: 0, autoAlpha: 1, filter: 'blur(0px)', duration: 0.8, ease: 'power2.out' }, 0.6);
      var boxDone = false;
      var boxGate = function () {
        if (!boxDone && susWrap.getBoundingClientRect().top < window.innerHeight * 0.30) {
          boxDone = true;
          boxTl.play();
          window.removeEventListener('scroll', boxGate);
        }
      };
      window.addEventListener('scroll', boxGate, { passive: true });
      boxGate();
    }

    if (steps.length) gsap.set(steps, { y: 18, autoAlpha: 0, filter: 'blur(6px)' });
    var stepsTween = steps.length
      ? gsap.to(steps, {
          y: 0, autoAlpha: 1, filter: 'blur(0px)', duration: 0.7, ease: 'power2.out', stagger: 0.15,
          paused: true
        })
      : null;

    /* 35% dwell at the end; its verified boundary also plays the steps. */
    function susDwellStart() {
      return docTop(susWrap) + Math.max(susWrap.offsetHeight - window.innerHeight, 0);
    }
    /* OFFSET DISABLED (restore by uncommenting; the slim trigger below keeps
       the steps firing at the same boundary):
    window.ScrollTrigger.create({
      trigger: susWrap,
      start: susDwellStart,
      end: function () { return susDwellStart() + Math.round(window.innerHeight * 0.35); },
      pin: true,
      pinSpacing: true,
      invalidateOnRefresh: true,
      onEnter: function () { if (stepsTween) stepsTween.play(); }
    });
    */
    window.ScrollTrigger.create({
      trigger: susWrap,
      start: susDwellStart,
      end: function () { return susDwellStart() + 1; },
      invalidateOnRefresh: true,
      onEnter: function () { if (stepsTween) stepsTween.play(); }
    });
  })();

  /* --- Three worlds: tiles get the showcase parallax treatment (oversized
         layers drifting with the section's on-screen position; the hover
         video layer drifts in sync with its image), and the head texts rise
         in subtly from below, once. --- */
  (function () {
    var wrap = document.querySelector('.shopify-section[id*="three_worlds"]');
    var sec = wrap && wrap.querySelector('.agnes-worlds');
    if (!wrap || !sec) return;

    var layers = sec.querySelectorAll('.agnes-worlds__image, .agnes-worlds__video');
    if (layers.length) {
      gsap.set(layers, { scale: 1.32 });
      var setters = Array.prototype.map.call(layers, function (el) {
        return gsap.quickSetter(el, 'yPercent');
      });
      var updWorlds = function () {
        var r = sec.getBoundingClientRect();
        var t = (window.innerHeight - r.top) / (window.innerHeight + r.height);
        t = Math.max(0, Math.min(1, t));
        var v = -15 + 30 * t;
        setters.forEach(function (s) { s(v); });
      };
      window.ScrollTrigger.create({
        trigger: wrap,
        start: 'top bottom',
        end: 'bottom top',
        onUpdate: updWorlds,
        onRefresh: updWorlds
      });
      updWorlds();
    }

    /* Head texts: subtle bottom→top fade-in, plays once and stays. */
    var bits = [];
    ['.agnes-worlds__eyebrow', '.agnes-worlds__title', '.agnes-worlds__intro'].forEach(function (s) {
      var el = sec.querySelector(s);
      if (el) bits.push(el);
    });
    if (bits.length) {
      gsap.set(bits, { y: 28, autoAlpha: 0 });
      var headDone = false;
      var headGate = function () {
        if (!headDone && sec.getBoundingClientRect().top < window.innerHeight * 0.75) {
          headDone = true;
          gsap.to(bits, { y: 0, autoAlpha: 1, duration: 1.1, ease: 'power2.out', stagger: 0.12 });
          window.removeEventListener('scroll', headGate);
        }
      };
      window.addEventListener('scroll', headGate, { passive: true });
      headGate();
    }
  })();

  /* --- Heritage (six generations): subtle once-only fade-ins — eyebrow,
         heading and CTA rise in softly, then the timeline milestones fade
         through in sequence. --- */
  (function () {
    var wrap = document.querySelector('.shopify-section[id*="heritage"]');
    var sec = wrap && wrap.querySelector('.agnes-heritage');
    if (!wrap || !sec) return;

    /* Background parallax: the image drifts with the section's on-screen
       position, oversized so the drift never shows edges (media clips). */
    var bg = sec.querySelector('.agnes-heritage__image');
    if (bg) {
      gsap.set(bg, { scale: 1.28 });
      var setBg = gsap.quickSetter(bg, 'yPercent');
      var updBg = function () {
        var r = sec.getBoundingClientRect();
        var p = (window.innerHeight - r.top) / (window.innerHeight + r.height);
        p = Math.max(0, Math.min(1, p));
        setBg(-12 + 24 * p);
      };
      window.ScrollTrigger.create({
        trigger: wrap,
        start: 'top bottom',
        end: 'bottom top',
        onUpdate: updBg,
        onRefresh: updBg
      });
      updBg();
    }

    var bits = [];
    ['.agnes-heritage__eyebrow', '.agnes-heritage__heading', '.agnes-heritage__link'].forEach(function (s) {
      var el = sec.querySelector(s);
      if (el) bits.push(el);
    });
    var miles = sec.querySelectorAll('.agnes-heritage__milestone');

    if (bits.length) gsap.set(bits, { y: 20, autoAlpha: 0 });

    /* Build the left→right timeline sequence: each connector segment draws
       across, and the dot + cap fade in as the line front reaches them. */
    /* connectors are SIBLINGS of the milestones inside the timeline row */
    var conns = sec.querySelectorAll('.agnes-heritage__connector');
    var tlSeq = gsap.timeline({ paused: true });
    Array.prototype.forEach.call(miles, function (m, i) {
      var pieces = [m.querySelector('.agnes-heritage__dot'), m.querySelector('.agnes-heritage__cap')].filter(Boolean);
      var conn = conns[i] || null;   // connector i follows milestone i
      if (pieces.length) gsap.set(pieces, { y: 14, autoAlpha: 0 });
      if (conn) gsap.set(conn, { scaleX: 0, transformOrigin: 'left center' });
      var at = i * 0.7;
      if (pieces.length) tlSeq.to(pieces, { y: 0, autoAlpha: 1, duration: 0.55, ease: 'power2.out' }, at);
      if (conn) tlSeq.to(conn, { scaleX: 1, duration: 0.6, ease: 'power1.inOut' }, at + 0.22);
    });
    if (!bits.length && !miles.length) return;

    var introDone = false;
    var introGate = function () {
      if (introDone || sec.getBoundingClientRect().top >= window.innerHeight * 0.75) return;
      introDone = true;
      window.removeEventListener('scroll', introGate);
      if (bits.length) {
        gsap.to(bits, { y: 0, autoAlpha: 1, duration: 1.0, ease: 'power2.out', stagger: 0.12 });
      }
    };
    window.addEventListener('scroll', introGate, { passive: true });
    introGate();

    /* Timeline waits for the END of the section to be in view. */
    var tlDone = false;
    var tlGate = function () {
      if (tlDone || sec.getBoundingClientRect().bottom > window.innerHeight + 2) return;
      tlDone = true;
      window.removeEventListener('scroll', tlGate);
      tlSeq.play();
    };
    window.addEventListener('scroll', tlGate, { passive: true });
    tlGate();
  })();

  /* --- Trusted by: logo images fade up, staggered left to right, once. --- */
  (function () {
    var wrap = document.querySelector('.shopify-section[id*="trusted_by"]');
    var sec = wrap && wrap.querySelector('.agnes-logos');
    if (!wrap || !sec) return;
    var items = sec.querySelectorAll('.agnes-logos__item');
    if (!items.length) return;
    gsap.set(items, { y: 16, autoAlpha: 0 });
    var done = false;
    var gate = function () {
      if (done || sec.getBoundingClientRect().bottom > window.innerHeight + 2) return;
      done = true;
      window.removeEventListener('scroll', gate);
      gsap.to(items, { y: 0, autoAlpha: 1, duration: 1.4, ease: 'power2.out', stagger: 0.3 });
    };
    window.addEventListener('scroll', gate, { passive: true });
    gate();
  })();

  /* --- Subpages (bespoke / our-world / the-artist / story): every section
         image gets parallax drift, and texts fade in subtly left → right,
         once each, as they enter. The hero blocks above already run here
         (same sweep intro + same curtain exit as home). --- */
  (function () {
    var main = document.querySelector('main[data-template]');
    if (!main || main.dataset.template !== 'page') return;

    /* Subpage styling: flat 15% black wash over the hero image (the setting-
       driven overlay is a bottom gradient — the top stays bare), and much
       tighter vertical rhythm on mobile. */
    var subStyle = document.createElement('style');
    subStyle.textContent =
      '.agnes-hero__media::after { content: ""; position: absolute; inset: 0; background: rgba(0,0,0,0.15); pointer-events: none; }' +
      '@media (max-width: 749px) {' +
        /* equal rhythm: one uniform gap between all section wrappers, and the
           sections stop adding their own uneven vertical paddings */
        '#MainContent { row-gap: 48px; }' +
        '.agnes-statement { padding-top: 24px !important; padding-bottom: 24px !important; }' +
        '.agnes-editorial--split, .agnes-editorial--contained { min-height: 0 !important; padding-top: 0 !important; padding-bottom: 0 !important; }' +
        '.agnes-editorial--overlay { min-height: 62svh !important; }' +
      '}';
    document.head.appendChild(subStyle);

    /* Image parallax: gentle drift inside each image's clipping holder —
       includes the quote section's small image and the form's backdrop. */
    var imgs = main.querySelectorAll(
      '.agnes-editorial__image, .agnes-worlds__image, .agnes-heritage__image,' +
      '.agnes-statement__image, .agnes-appointment__bg-image'
    );
    var drivers = [];
    Array.prototype.forEach.call(imgs, function (img) {
      var holder = img.closest(
        '.agnes-editorial__media, .agnes-worlds__media, .agnes-heritage__media, .agnes-appointment__bg'
      ) || img.parentElement;
      if (!holder) return;
      gsap.set(holder, { overflow: 'hidden' });   // the oversized layer must clip
      /* Per-image zoom: each asset is baked as its design window x its own max
         affordable margin (data-pscale). Drift shrinks with the margin so the
         edges never show; at zero margin the image sits statically on the
         design crop. Mid-travel always shows the design window exactly. */
      /* Uniform motion: one zoom + one drift for every image. Assets are baked
         so mid-travel shows the design window exactly where the source photo
         affords a 12% margin, and within ~6% where it doesn't. */
      var ps = 1.12;
      var amp = 5;
      gsap.set(img, { scale: ps });
      var set = gsap.quickSetter(img, 'yPercent');
      drivers.push(function () {
        var r = holder.getBoundingClientRect();
        if (r.bottom < -60 || r.top > window.innerHeight + 60) return;
        var p = (window.innerHeight - r.top) / (window.innerHeight + r.height);
        p = Math.max(0, Math.min(1, p));
        set(-amp + 2 * amp * p);
      });
    });
    if (drivers.length) {
      gsap.ticker.add(function () {
        for (var i = 0; i < drivers.length; i++) drivers[i]();
      });
    }

    /* Text fade-ins, left → right, once per element (hero owns its own). */
    var texts = main.querySelectorAll(
      '[class*="__eyebrow"], [class*="__heading"], [class*="__intro"], [class*="__body"],' +
      '[class*="__desc"], [class*="__title"], [class*="__btn"], [class*="__link"], [class*="__step"]'
    );
    var seen = [];
    Array.prototype.forEach.call(texts, function (el) {
      if (el.closest('.agnes-hero')) return;                       // hero sweep owns these
      if (el.closest('.agnes-appointment')) return;                // the form stays static
      if (el.closest('.agnes-statement')) return;                  // quote sections stay in place
      if (el.closest('.agnes-editorial--overlay')) return;         // full-screen texts stay in place
      if (seen.some(function (s) { return s.contains(el); })) return;  // outermost only
      seen.push(el);
      /* desktop: from the left; mobile/tablet: from below */
      if (DESKTOP) gsap.set(el, { x: -24, autoAlpha: 0 });
      else gsap.set(el, { y: 24, autoAlpha: 0 });
    });
    if (seen.length && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (!en.isIntersecting) return;
          io.unobserve(en.target);
          gsap.to(en.target, { x: 0, y: 0, autoAlpha: 1, duration: 0.9, ease: 'power2.out' });
        });
      }, { threshold: 0.2 });
      seen.forEach(function (el) { io.observe(el); });
    } else {
      seen.forEach(function (el) { gsap.set(el, { x: 0, y: 0, autoAlpha: 1 }); });
    }
  })();

  /* --- Mobile/tablet: home sections whose transitions are desktop-only get a
         parallax background instead (the four editorials — piece, woman,
         budapest, sustainability). --- */
  (function () {
    if (DESKTOP) return;
    var mainEl = document.querySelector('main[data-template]');
    if (!mainEl || mainEl.dataset.template !== 'index') return;
    var drivers = [];
    function addParallax(holder, layer, clipEl) {
      if (!holder || !layer) return;
      if (clipEl) gsap.set(clipEl, { overflow: 'hidden' });
      gsap.set(layer, { scale: 1.18 });
      var set = gsap.quickSetter(layer, 'yPercent');
      drivers.push(function () {
        var r = holder.getBoundingClientRect();
        if (r.bottom < -60 || r.top > window.innerHeight + 60) return;
        var p = (window.innerHeight - r.top) / (window.innerHeight + r.height);
        p = Math.max(0, Math.min(1, p));
        set(-8 + 16 * p);
      });
    }
    /* editorials: scale the media's INNER layer (img or slideshow) and clip at
       the media box — scaling the media itself bled it over the text block on
       the stacked mobile layouts. */
    Array.prototype.forEach.call(mainEl.querySelectorAll('.agnes-editorial .agnes-editorial__media'), function (m) {
      var sec = m.closest('.agnes-editorial');
      addParallax(sec, m.firstElementChild || m, m);
    });
    /* hero: the video/image inside its clipped media wrapper */
    var heroMedia = mainEl.querySelector('.agnes-hero__media');
    if (heroMedia) {
      addParallax(heroMedia, heroMedia.querySelector('video, img'), heroMedia);
    }
    /* category tiles: each image inside its overflow-hidden tile */
    Array.prototype.forEach.call(mainEl.querySelectorAll('.agnes-cats__tile'), function (tile) {
      addParallax(tile, tile.querySelector('.agnes-cats__image'), tile);
    });
    if (drivers.length) {
      gsap.ticker.add(function () {
        for (var i = 0; i < drivers.length; i++) drivers[i]();
      });
    }
  })();

})();

/* Reload veil: lift as soon as the engine is fully built (first stable frame). */
requestAnimationFrame(function () { requestAnimationFrame(function () { if (window.__agnesSnapJump) window.__agnesSnapJump(); }); });
